export const getSiteName = () => {
  try {
    const { hostname, port } = window.location;
    if (port) {
      return `${hostname}:${port}`;
    }
    return hostname;
  } catch {
    return '';
  }
};
